/* Panier Soleil d'Or — page /cart ET tiroir panier (Numerigram, octobre 2026).
   Chargé par templates/cart.json (page) et sections/cart-drawer.liquid (tiroir, toutes les pages).
   Données de livraison : <script id="sdo-livraison-pays"> = shop.metafields.sdo.livraison.pays[pays]
   (grille Transporteurs : mode, point relais, franco, grille de port, délai, retours).
   1. Marque au-dessus du nom de chaque article ; lien « Retirer » (page).
   2. Phrase de livraison offerte : « Plus que 12,40 € pour la livraison offerte en point relais ».
   3. Récapitulatif : « Payé au Soleil d'Or » (sous-total, livraison à partir de / offerte, total du jour)
      puis, hors UE, « Payé au transporteur » (estimation douane de sdo-douanes-panier, calcul inchangé).
   4. Sous les boutons : soleils Golden Club (une ligne). Les autres réassurances sont dans la section du thème.
   5. Page, mobile : barre « Commander » fixée en bas tant que le vrai bouton est plus bas.
   Rien ne touche aux CGV, à la douane, au papier cadeau ni au paiement. FR / EN. */
(function () {
  if (window.__sdoPanier) return;
  window.__sdoPanier = true;

  var en = (document.documentElement.lang || '').toLowerCase().indexOf('en') === 0;
  var UE = 'AT,BE,BG,CY,CZ,DE,DK,EE,ES,FI,FR,GR,HR,HU,IE,IT,LT,LU,LV,MT,NL,PL,PT,RO,SE,SI,SK'.split(',');
  var pays = (window.Shopify && Shopify.country) || 'FR';
  var devise = (window.Shopify && Shopify.currency && Shopify.currency.active) || 'EUR';
  var taux = parseFloat(window.Shopify && Shopify.currency && Shopify.currency.rate) || 1;
  function T(fr, an) { return en ? an : fr; }
  var panier = null;
  var liv = null;

  function lireLivraison() {
    if (liv) return liv;
    var s = document.getElementById('sdo-livraison-pays');
    if (!s) return null;
    try { liv = JSON.parse(s.textContent); } catch (e) { liv = null; }
    return liv;
  }

  var fmt;
  try { fmt = new Intl.NumberFormat(en || devise !== 'EUR' ? 'en-GB' : 'fr-FR', { style: 'currency', currency: devise, currencyDisplay: 'narrowSymbol' }); }
  catch (e) { fmt = { format: function (n) { return n.toFixed(2) + ' ' + devise; } }; }
  function prix(n) { return fmt.format(n).replace(/[.,]00(?=[^0-9]|$)/, ''); }

  function chargerPanier() {
    return fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (c) { panier = c; })
      .catch(function () {});
  }

  function ecrire(e, txt) { if (e && e.textContent !== txt) e.textContent = txt; }
  function el(tag, cls, txt) { var e = document.createElement(tag); if (cls) e.className = cls; if (txt) e.textContent = txt; return e; }

  /* ── Livraison selon le pays : toutes les méthodes publiées par l'app Transporteurs (grille + tarifs),
     on retient la MOINS CHÈRE pour le montant du panier ; livraison offerte dès le seuil le plus bas du pays. ── */
  var NOMS_EN = { 'Colissimo Point Relais': 'Colissimo pickup point', 'Colissimo Domicile avec Signature': 'Colissimo home delivery (signature)', 'Colissimo Domicile': 'Colissimo home delivery' };
  function nomMethode(n) { return en ? (NOMS_EN[n] || n) : n; }
  function ouMethode(n) {
    if (/relais/i.test(n)) return T('en point relais', 'to a pickup point');
    if (/fedex/i.test(n)) return T('avec FedEx', 'with FedEx');
    return T('à domicile', 'to your door');
  }
  function prixGrille(g, total) {
    var p = null;
    (g || []).forEach(function (l) { if (total >= l[0] && (l[1] === null || total <= l[1])) p = l[2]; });
    return p;
  }
  function seuilGrille(g) {
    var s = null;
    (g || []).forEach(function (l) { if (l[2] === 0 && (s === null || l[0] < s)) s = l[0]; });
    return s;
  }
  function infoLivraison() {
    var L = lireLivraison();
    if (!L || L.devise !== devise || !panier) return null;
    var total = panier.total_price / 100;
    var methodes = [];
    var tarifs = L.tarifs || {};
    if (L.grille) {
      var nomG = L.relais ? 'Colissimo Point Relais' : (Object.keys(tarifs)[0] || (L.mode === 'fedex' ? 'FedEx' : 'Colissimo Domicile'));
      methodes.push({ nom: nomG, grille: L.grille });
    }
    Object.keys(tarifs).forEach(function (n) {
      if (!methodes.some(function (m) { return m.nom === n; })) methodes.push({ nom: n, grille: tarifs[n] });
    });
    var moins = null, offerte = null;
    methodes.forEach(function (m) {
      m.prix = prixGrille(m.grille, total);
      m.seuil = seuilGrille(m.grille);
      if (m.prix !== null && (moins === null || m.prix < moins.prix)) moins = m;
      if (m.seuil !== null && (offerte === null || m.seuil < offerte.seuil)) offerte = m;
    });
    var delai = L.delai ? (L.delai[0] + T(' à ', '–') + L.delai[1] + T(' jours ouvrés', ' business days')) : '';
    if (!moins) return { port: null, franco: null, reste: null, mode: '', ou: '', delai: delai, retour: L.retour || null };
    var franco = offerte ? offerte.seuil : null;
    var gratuit = moins.prix === 0;
    return {
      port: moins.prix,
      franco: franco,
      reste: franco === null ? null : Math.max(0, franco - total),
      mode: nomMethode(moins.nom),
      ou: ouMethode(gratuit ? moins.nom : (offerte ? offerte.nom : moins.nom)),
      delai: delai,
      retour: L.retour || null
    };
  }

  /* ── Phrase au-dessus de la barre de livraison offerte ── */
  function phrase(scope, info) {
    var msg = scope.querySelector('.free-shipping__message');
    if (!msg || !info || info.reste === null) return;
    ecrire(msg, info.reste > 0
      ? T('Plus que ' + prix(info.reste) + ' pour la livraison offerte ' + info.ou, 'Only ' + prix(info.reste) + ' away from free delivery ' + info.ou)
      : T('Livraison offerte ' + info.ou, 'Free delivery ' + info.ou));
  }

  /* ── Lignes articles : marque ; lien Retirer (page) ── */
  function marqueDe(li) {
    if (!panier) return '';
    var cle = li.getAttribute('data-key');
    var nom = li.querySelector('.cart-item__name');
    var href = nom ? (nom.getAttribute('href') || '').split('?')[0] : '';
    var m = '';
    (panier.items || []).forEach(function (it) {
      if (m) return;
      if (cle && it.key === cle) m = it.vendor;
      else if (!cle && href && it.url && it.url.split('?')[0] === href) m = it.vendor;
    });
    return m || '';
  }
  function lignes(scope, page) {
    scope.querySelectorAll('.cart__item').forEach(function (li) {
      if (li.hasAttribute('data-gift-wrapping-id')) return;
      var nom = li.querySelector('.cart-item__name');
      var titre = nom ? nom.parentNode : null;
      var marque = marqueDe(li);
      if (titre && marque && !titre.querySelector('.sdo-pn-marque')) titre.insertBefore(el('p', 'sdo-pn-marque', marque), nom);
      if (!page) return;
      var qte = li.querySelector('.cart__quantity');
      var suppr = li.querySelector('cart-remove-button a');
      if (qte && suppr && !li.querySelector('.sdo-pn-retirer')) {
        var b = el('button', 'sdo-pn-retirer', T('Retirer', 'Remove'));
        b.type = 'button';
        b.addEventListener('click', function () { suppr.click(); });
        var details = li.querySelector('.cart__product-details');
        if (details) { var w = el('li', 'sdo-pn-retirer-li'); w.appendChild(b); details.appendChild(w); }
        else (titre || qte).appendChild(b);
      }
    });
  }

  function ligne(parent, cls) {
    var p = el('p', 'sdo-pn-recap__ligne' + (cls ? ' ' + cls : ''));
    p.appendChild(el('span'));
    p.appendChild(el('span'));
    parent.appendChild(p);
    return p;
  }

  /* ── Récapitulatif ── */
  function recap(scope, ancre, info, tiroir) {
    var valeur = scope.querySelector('.cart__totals__subtotal-value');
    if (!ancre || !valeur) return;
    var bloc = scope.querySelector('.sdo-pn-recap');
    if (!bloc) {
      bloc = el('div', 'sdo-pn-recap');
      bloc.innerHTML = '<p class="sdo-pn-recap__titre"></p><div class="sdo-pn-recap__nous"></div><div class="sdo-pn-recap__douane"><p class="sdo-pn-recap__titre"></p><div></div><p class="sdo-pn-recap__note"></p></div>';
      var nous = bloc.querySelector('.sdo-pn-recap__nous');
      ligne(nous, 'is-sous-total'); ligne(nous, 'is-livraison');
      nous.appendChild(el('p', 'sdo-pn-recap__mode'));
      ligne(nous, 'is-total');
      ligne(bloc.querySelector('.sdo-pn-recap__douane > div'), 'is-droits');
    }
    if (bloc.previousElementSibling !== ancre) ancre.parentNode.insertBefore(bloc, ancre.nextSibling);

    var ht = valeur.querySelector('.cart__totals__tax-note');
    var montant = valeur.textContent;
    if (ht) montant = montant.replace(ht.textContent, '');
    montant = montant.replace(/ +/g, ' ').trim();
    var fill = scope.querySelector('.free-shipping-scale__fill');
    var offerte = info && info.port !== null ? info.port === 0 : (!!fill && parseFloat(fill.style.width) >= 100);

    ecrire(bloc.firstChild, T('Payé au Soleil d’Or', 'Paid to Soleil d’Or'));
    var st = bloc.querySelector('.is-sous-total');
    ecrire(st.firstChild, T('Sous-total', 'Subtotal') + (ht ? T(' (hors taxes)', ' (excl. tax)') : ''));
    ecrire(st.lastChild, montant);
    var lv = bloc.querySelector('.is-livraison');
    ecrire(lv.firstChild, T('Livraison', 'Shipping'));
    ecrire(lv.lastChild, offerte ? T('Offerte', 'Free')
      : (info && info.port !== null ? T('à partir de ', 'from ') + prix(info.port) : T('Calculée à l’étape suivante', 'Calculated at checkout')));
    var md = bloc.querySelector('.sdo-pn-recap__mode');
    if (!md.querySelector('.sdo-pn-recap__retrait')) {
      md.textContent = '';
      md.appendChild(el('span', 'sdo-pn-recap__methode'));
      var rt = el('span', 'sdo-pn-recap__retrait');
      rt.style.display = 'block';
      md.appendChild(rt);
    }
    var txtMode = info && info.mode ? info.mode + (info.delai ? ' · ' + info.delai : '') : '';
    /* France : le retrait gratuit en boutique (Lille, prêt en 1 h) est aussi proposé au paiement */
    var txtRetrait = pays === 'FR' ? T('Ou retrait gratuit en boutique à Lille, prêt en 1 h', 'Or free in-store pickup in Lille, ready in 1 hour') : '';
    ecrire(md.firstChild, txtMode);
    ecrire(md.lastChild, txtRetrait);
    md.firstChild.style.display = txtMode ? '' : 'none';
    md.lastChild.style.display = txtRetrait ? 'block' : 'none';
    md.hidden = !(txtMode || txtRetrait);
    var tt = bloc.querySelector('.is-total');
    ecrire(tt.firstChild, offerte ? T('Total à payer aujourd’hui', 'Total to pay today') : T('Total hors livraison', 'Total before shipping'));
    ecrire(tt.lastChild, montant);

    var hors = UE.indexOf(pays) === -1;
    var douane = bloc.querySelector('.sdo-pn-recap__douane');
    douane.hidden = !hors;
    if (hors) {
      var porteur = scope.querySelector('.sdo-douanes-panier');
      var texte = porteur ? (porteur.getAttribute('data-sdo-douanes-text') || '') : '';
      var cle = en ? 'about ' : 'environ ';
      var estim = texte.indexOf(cle) > -1 ? texte.split(cle)[1].split(', ')[0].trim() : '';
      ecrire(douane.firstChild, T('Payé au transporteur, à la livraison', 'Paid to the carrier, on delivery'));
      var dr = douane.querySelector('.is-droits');
      ecrire(dr.firstChild, T('Droits et taxes d’import', 'Import duties and taxes'));
      ecrire(dr.lastChild, estim ? '≈ ' + estim : T('Selon votre pays', 'Depends on your country'));
      ecrire(douane.lastChild, T('À reverser au transporteur à la réception de la commande.', 'To be paid to the carrier when your order is delivered.'));
    }
  }

  /* ── Texte sous la case CGV replié derrière « Voir plus » (le texte reste dans la page, rien ne change à la case) ── */
  function cgv(scope) {
    scope.querySelectorAll('.cgv-consent__note').forEach(function (note) {
      var label = note.parentNode;
      /* Livraison dans l'UE : le thème laisse la note vide, donc pas de « Voir plus » */
      var cible = note.querySelector('[data-sdo-douanes-target]');
      var txt = note.textContent.replace(cible ? cible.textContent : '', '').trim();
      if (!txt) {
        var vieux = label && label.querySelector('.sdo-cgv-plus');
        if (vieux) vieux.remove();
        note.classList.remove('is-replie');
        return;
      }
      if (!label || label.querySelector('.sdo-cgv-plus')) return;
      note.classList.add('is-replie');
      var b = el('button', 'sdo-cgv-plus', T('Voir plus', 'See more'));
      b.type = 'button';
      b.setAttribute('aria-expanded', 'false');
      b.addEventListener('click', function (e) {
        e.preventDefault(); e.stopPropagation();
        var ouvert = note.classList.toggle('is-replie') === false;
        b.textContent = ouvert ? T('Voir moins', 'See less') : T('Voir plus', 'See more');
        b.setAttribute('aria-expanded', String(ouvert));
      });
      label.appendChild(b);
    });
  }

  /* ── Réassurance sous les boutons ── */
  function reassurance(scope, ancre, info, complet) {
    if (!ancre) return;
    var bloc = scope.querySelector('.sdo-pn-rassure');
    if (!bloc) { bloc = el('ul', 'sdo-pn-rassure'); bloc.setAttribute('role', 'list'); }
    if (bloc.previousElementSibling !== ancre) ancre.parentNode.insertBefore(bloc, ancre.nextSibling);
    var items = [];
    var n = panier ? Math.floor(panier.total_price / 100 / taux) : 0;
    if (!complet) {
      /* Tiroir : une seule ligne, le détail reste sur la page panier */
      if (n > 0) items.push({ k: 'golden', html: '<strong>+ ' + n + T(' soleils', ' suns') + '</strong> ' + T('avec le ', 'with the ') + '<a href="/pages/golden-club" target="_blank" rel="noopener">Golden Club</a>' });
    } else if (n > 0) {
      /* Page : la même information en phrase ; les autres réassurances sont déjà dans la section du thème sous le panier */
      items.push({ k: 'golden', html: T('Cette commande vous rapporte <strong>' + n + ' soleils</strong>. ', 'This order earns you <strong>' + n + ' suns</strong>. ') + '<a href="/pages/golden-club" target="_blank" rel="noopener">' + T('Découvrir le Golden Club', 'Discover the Golden Club') + '</a>' });
    }
    bloc.hidden = !items.length;
    var sig = items.map(function (i) { return i.k + (i.txt || i.html); }).join('|');
    if (bloc.getAttribute('data-sig') === sig) return;
    bloc.setAttribute('data-sig', sig);
    bloc.innerHTML = '';
    items.forEach(function (i) {
      var li = el('li', 'sdo-pn-rassure__item is-' + i.k);
      if (i.html) li.innerHTML = i.html; else li.textContent = i.txt;
      bloc.appendChild(li);
    });
    var chat = bloc.querySelector('.sdo-pn-rassure__chat');
    if (chat) chat.addEventListener('click', function () {
      if (window.GorgiasChat && typeof GorgiasChat.open === 'function') GorgiasChat.open();
      else window.location.href = '/pages/contact';
    });
  }

  /* ── Page : options (message cadeau, note, frais de port) sous les articles, ouvertes sur place ── */
  var options = null;
  function placerOptions(page) {
    var liste = page.querySelector('cart-items');
    if (!liste) return;
    var m = page.querySelector('#main-cart-footer cart-footer-modal');
    if (m && m !== options) { if (options && options.parentNode) options.remove(); options = m; }
    if (!options) return;
    options.classList.add('sdo-pn-options');
    if (!options.__sdo && typeof options.openFooterModal === 'function') {
      /* Une seule option ouverte à la fois, juste sous sa ligne ; un second clic la referme */
      options.__sdo = true;
      var ouvrir = options.openFooterModal.bind(options);
      var fermer = options.closeFooterModal.bind(options);
      options.closeFooterModal = function (c) {
        [].forEach.call(this.querySelectorAll('.cart__footer-notes > button.sdo-ouvert'), function (bt) { bt.classList.remove('sdo-ouvert'); });
        fermer(c);
      };
      options.openFooterModal = function (c) {
        var bloc = this.querySelector('.cart__footer-modal__' + c);
        var dejaOuvert = this.cartFooterModal.classList.contains('open') && bloc && !bloc.classList.contains('hidden');
        this.closeFooterModal();
        if (dejaOuvert) return;
        var rang = 0, bouton = null;
        [].forEach.call(this.querySelectorAll('.cart__footer-notes > button'), function (bt, i) {
          if ((bt.getAttribute('onclick') || '').indexOf("'" + c + "'") > -1) { rang = i; bouton = bt; }
        });
        this.cartFooterModal.style.order = String(rang * 2 + 2);
        ouvrir(c);
        if (bouton) bouton.classList.add('sdo-ouvert');
      };
    }
    if (liste.lastElementChild !== options) liste.appendChild(options);
  }

  /* ── Page : bandeau défilant sous les articles, comme celui de la fiche produit, adapté au panier ── */
  var ICONES = {
    livraison: '<path d="M3 7h11v9H3zM14 10h4l3 3v3h-7"/><circle cx="7" cy="17.5" r="1.5"/><circle cx="17" cy="17.5" r="1.5"/>',
    soleil: '<circle cx="12" cy="12" r="4"/><path d="M12 2v2M12 20v2M2 12h2M20 12h2M4.9 4.9l1.4 1.4M17.7 17.7l1.4 1.4M4.9 19.1l1.4-1.4M17.7 6.3l1.4-1.4"/>',
    echantillon: '<path d="M9 3h6M10 3v6l-4 9a2 2 0 0 0 2 3h8a2 2 0 0 0 2-3l-4-9V3"/>',
    box: '<path d="M3 8l9-5 9 5v8l-9 5-9-5z"/><path d="M3 8l9 5 9-5M12 13v8"/>',
    conseil: '<path d="M4 5h16v11H9l-5 4z"/>'
  };
  function icone(n) { return '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">' + ICONES[n] + '</svg>'; }
  function echapper(t) { return String(t).replace(/&/g, '&amp;').replace(/</g, '&lt;'); }
  function defile(page, info) {
    var ancre = page.querySelector('cart-items > form');
    if (!ancre) return;
    var bloc = page.querySelector('.sdo-pn-defile');
    if (!bloc) {
      bloc = el('div', 'sdo-pn-defile');
      bloc.setAttribute('role', 'region');
      bloc.setAttribute('aria-label', T('Les avantages de votre commande', 'Your order benefits'));
      bloc.innerHTML = '<div class="sdo-pn-defile__piste"></div>';
      bloc.addEventListener('click', function (e) {
        var t = e.target.closest('[data-sdo-action]');
        if (!t) return;
        e.preventDefault();
        if (t.getAttribute('data-sdo-action') === 'note' && options) {
          var note = options.querySelector('.cart__footer-modal__cart-note');
          if (!note || note.classList.contains('hidden')) options.openFooterModal('cart-note');
          options.scrollIntoView({ behavior: 'smooth', block: 'center' });
        } else if (t.getAttribute('data-sdo-action') === 'chat') {
          if (window.GorgiasChat && typeof GorgiasChat.open === 'function') GorgiasChat.open();
          else window.location.href = '/pages/contact';
        }
      });
    }
    if (bloc.previousElementSibling !== ancre) ancre.parentNode.insertBefore(bloc, ancre.nextSibling);
    var n = panier ? Math.floor(panier.total_price / 100 / taux) : 0;
    var items = [];
    if (info && info.mode) {
      items.push({ ic: 'livraison', href: '/policies/shipping-policy',
        val: info.reste === 0 || info.port === 0 ? T('Livraison offerte', 'Free delivery') : (info.franco ? T('Offerte dès ', 'Free from ') + prix(info.franco) : T('Livraison', 'Delivery')),
        sub: info.mode + (info.delai ? ' · ' + info.delai : '') });
    }
    if (n > 0) items.push({ ic: 'soleil', href: '/pages/golden-club', val: '+' + n + T(' soleils', ' suns'), sub: 'Golden Club' });
    items.push({ ic: 'echantillon', action: 'note', val: T('Jusqu’à 3 échantillons', 'Up to 3 samples'), sub: T('À demander en note de commande', 'Ask in your order note') });
    items.push({ ic: 'box', href: '/products/box-decouverte', val: T('Box Découverte', 'Discovery box'), sub: T('Découvrez avant d’acheter', 'Try before you buy') });
    items.push({ ic: 'conseil', action: 'chat', val: T('Une question ?', 'A question?'), sub: T('Nos conseillers vous répondent', 'Our advisers are here to help') });
    var sig = items.map(function (i) { return i.val + i.sub; }).join('|');
    if (bloc.getAttribute('data-sig') === sig) return;
    bloc.setAttribute('data-sig', sig);
    function serie(cache) {
      return items.map(function (i) {
        var txt = icone(i.ic) + '<span class="sdo-pn-defile__txt"><span class="sdo-pn-defile__val">' + echapper(i.val) + '</span><span class="sdo-pn-defile__sub">' + echapper(i.sub) + '</span></span>';
        var tab = cache ? ' tabindex="-1"' : '';
        return (i.href
          ? '<a class="sdo-pn-defile__item" href="' + i.href + '" target="_blank" rel="noopener"' + tab + '>' + txt + '</a>'
          : '<button type="button" class="sdo-pn-defile__item" data-sdo-action="' + i.action + '"' + tab + '>' + txt + '</button>')
          + '<span class="sdo-pn-defile__sep" aria-hidden="true">✷</span>';
      }).join('');
    }
    bloc.firstChild.innerHTML = '<div class="sdo-pn-defile__serie">' + serie(false) + '</div><div class="sdo-pn-defile__serie" aria-hidden="true">' + serie(true) + '</div>';
  }

  /* ── Photos, même règle que la galerie de la fiche produit :
     format proche du cadre (écart ≤ 20 %) → la photo remplit le cadre ;
     sinon photo entière, et le cadre prend le fond de la photo (couleur unie, ou la photo floutée).
     Fond blanc ou transparent : cadre crème habituel. Jamais déformée. ── */
  function fond(img, cadre) {
    if (!img || !cadre) return;
    if (img.__sdoFond) { img.__sdoFond(); return; }
    function nettoyer() {
      var f = cadre.querySelector(':scope > .sdo-pn-flou');
      if (f) f.remove();
      cadre.style.removeProperty('background');
      img.style.removeProperty('mix-blend-mode');
      img.style.removeProperty('object-fit');
    }
    function appliquer() {
      if (!img.naturalWidth || !cadre.offsetWidth || !cadre.offsetHeight) return;
      var ri = img.naturalWidth / img.naturalHeight, rc = cadre.offsetWidth / cadre.offsetHeight;
      var cle = img.currentSrc + '|' + Math.round(rc * 100);
      if (img.getAttribute('data-sdo-fond') === cle) return;
      img.setAttribute('data-sdo-fond', cle);
      var w = 40, h = Math.max(4, Math.round(40 / ri)), px;
      var c = document.createElement('canvas'); c.width = w; c.height = h;
      var x = c.getContext('2d');
      try {
        x.drawImage(img, 0, 0, w, h);
        px = [[1, 1], [w - 2, 1], [1, h - 2], [w - 2, h - 2], [1, h >> 1], [w - 2, h >> 1]].map(function (p) { return x.getImageData(p[0], p[1], 1, 1).data; });
      } catch (e) { return; }
      var m = [0, 1, 2].map(function (k) { return px.reduce(function (t, p) { return t + p[k]; }, 0) / px.length; });
      var ecart = 0, alpha = 255, blanc = true;
      px.forEach(function (p) {
        alpha = Math.min(alpha, p[3]);
        for (var k = 0; k < 3; k++) { ecart = Math.max(ecart, Math.abs(p[k] - m[k])); if (p[k] < 238) blanc = false; }
      });
      nettoyer();
      if (alpha < 250 || blanc) return;
      img.style.setProperty('mix-blend-mode', 'normal', 'important');
      /* Le cadre prend aussi la couleur des bords de la photo : pas de liseré autour */
      cadre.style.setProperty('background', 'rgb(' + m.map(Math.round).join(',') + ')', 'important');
      if (Math.abs(ri / rc - 1) <= 0.2) { img.style.setProperty('object-fit', 'cover', 'important'); return; }
      if (ecart > 18) {
        var flou = el('span', 'sdo-pn-flou');
        flou.setAttribute('aria-hidden', 'true');
        flou.style.backgroundImage = 'url("' + img.currentSrc.replace(/"/g, '%22') + '")';
        cadre.style.isolation = 'isolate';
        cadre.style.overflow = 'hidden';
        cadre.insertBefore(flou, cadre.firstChild);
        img.style.zIndex = '1';
      }
    }
    img.__sdoFond = appliquer;
    img.addEventListener('load', appliquer);
    if (window.ResizeObserver) new ResizeObserver(appliquer).observe(cadre);
    appliquer();
  }
  /* Panier, tiroir et toutes les cartes produit du site (accueil, carrousels, collections, suggestions) */
  function photos() {
    document.querySelectorAll('#main-cart .cart__image-box img, cart-drawer .cart__image-box img, .product-card__image .media img').forEach(function (im) {
      fond(im, im.closest('.cart__image-box, .media'));
    });
  }

  /* ── Tiroir : suggestions avec la marque, comme les cartes produit ; bouton court ── */
  var marquesSugg = {};
  function suggestionsTiroir(tiroir) {
    tiroir.querySelectorAll('.cart-drawer-recommendations product-item').forEach(function (it) {
      it.querySelectorAll('.btn span, button span').forEach(function (sp) {
        if (/sélectionnez les options|select options/i.test(sp.textContent)) sp.textContent = T('Choisir', 'Choose');
      });
      var nom = it.querySelector('.cart-item__name');
      if (!nom || it.querySelector('.sdo-pn-marque')) return;
      var url = (nom.getAttribute('href') || '').split('?')[0];
      if (!url) return;
      var poser = function (v) { if (v && !it.querySelector('.sdo-pn-marque')) nom.parentNode.insertBefore(el('p', 'sdo-pn-marque', v), nom); };
      if (url in marquesSugg) { poser(marquesSugg[url]); return; }
      marquesSugg[url] = '';
      fetch(url + '.js', { headers: { Accept: 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (p) { marquesSugg[url] = p.vendor || ''; poser(marquesSugg[url]); })
        .catch(function () {});
    });
  }

  /* ── Barre « Commander » mobile (page) ── */
  var barre = null;
  function verifier(racine) {
    if (!barre) return;
    var z = racine.querySelector('.cart__submit');
    var r = z ? z.getBoundingClientRect() : null;
    var on = !barre.hidden && !!r && r.height > 0 && r.top > window.innerHeight;
    if (barre.classList.contains('is-visible') !== on) {
      barre.classList.toggle('is-visible', on);
      document.documentElement.classList.toggle('sdo-pn-barre-on', on);
    }
  }
  function majBarre(racine) {
    if (!barre) {
      barre = el('div', 'sdo-pn-barre');
      barre.innerHTML = '<p class="sdo-pn-barre__total"><span></span><strong></strong></p><button type="button" class="sdo-pn-barre__btn"></button>';
      barre.querySelector('button').textContent = T('Commander', 'Checkout');
      barre.querySelector('button').addEventListener('click', function () {
        var zone = racine.querySelector('.cart__submit-controls') || document.getElementById('main-cart-footer');
        if (zone) zone.scrollIntoView({ behavior: 'smooth', block: 'center' });
      });
      document.body.appendChild(barre);
      var v = function () { verifier(racine); };
      window.addEventListener('scroll', v, { passive: true });
      window.addEventListener('resize', v);
      window.addEventListener('load', v);
    }
    var val = racine.querySelector('.cart__totals__subtotal-value');
    var txt = val ? val.textContent : '';
    var ht = val ? val.querySelector('.cart__totals__tax-note') : null;
    if (ht) txt = txt.replace(ht.textContent, '');
    ecrire(barre.querySelector('strong'), txt.replace(/ +/g, ' ').trim());
    ecrire(barre.querySelector('span'), ht ? T('Sous-total hors taxes', 'Subtotal excl. tax') : T('Sous-total', 'Subtotal'));
    barre.hidden = !racine.querySelector('.cart__item');
    verifier(racine);
  }

  /* ── Orchestration ── */
  function tout() {
    var info = infoLivraison();
    var page = document.getElementById('main-cart');
    if (page && page.querySelector('.cart__item')) {
      lignes(page, true);
      phrase(page, info);
      recap(page, page.querySelector('.cart__total-details'), info);
      cgv(page);
      placerOptions(page);
      defile(page, info);
      majBarre(page);
    } else if (barre) { barre.hidden = true; verifier(page || document.body); }
    var tiroir = document.querySelector('cart-drawer');
    if (tiroir && tiroir.querySelector('.cart__item')) {
      lignes(tiroir, false);
      phrase(tiroir, info);
      recap(tiroir, tiroir.querySelector('.cart-drawer__footer'), info, true);
      cgv(tiroir);
      var gc = tiroir.querySelector('.sdo-pn-rassure');
      if (gc) gc.remove();
      suggestionsTiroir(tiroir);
    }
    photos();
  }

  var attente = null, signature = '';
  function plusTard() {
    clearTimeout(attente);
    attente = setTimeout(function () {
      var cles = [].map.call(document.querySelectorAll('.cart__item'), function (li) { return li.getAttribute('data-key') || li.id; });
      var tot = document.querySelector('.cart__totals__subtotal-value');
      var sig = cles.join(',') + '|' + (tot ? tot.textContent : '');
      if (sig !== signature) { signature = sig; chargerPanier().then(tout); } else tout();
    }, 120);
  }

  chargerPanier().then(tout);
  new MutationObserver(plusTard).observe(document.body, { childList: true, subtree: true });
})();
